import { render, staticRenderFns } from "./FamilyReport.vue?vue&type=template&id=fe7316b2&scoped=true&"
import script from "./FamilyReport.vue?vue&type=script&lang=js&"
export * from "./FamilyReport.vue?vue&type=script&lang=js&"
import style0 from "./FamilyReport.vue?vue&type=style&index=0&id=fe7316b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7316b2",
  null
  
)

export default component.exports